// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sp-6";
export var imgContainer = "_sp-3";
export var menuIcon = "_sp-5";
export var pillWrapper = "_sp-2";
export var pillsContainer = "_sp-1";
export var subscriptionCard = "_sp-0";
export var subscriptionLogo = "_sp-4";